import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../module/component/TableBoxModule';
import { PATH_DELIMITER } from '../../constant/Constant';
import { request } from '../ApiModule';

const BASE = 'modal/SUBJECT_CODE_SEARCH';
const ACTION_INIT = BASE + PATH_DELIMITER + 'ACTION_INIT';
const ACTION_SEARCH = BASE + PATH_DELIMITER + 'ACTION_SEARCH';
const HANDLE_DATA = BASE + PATH_DELIMITER + 'HANDLE_DATA';

export const actionInit = createAction(ACTION_INIT);
export const actionSearch = createAction(ACTION_SEARCH);

export function* subjectCodeSearchSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
}

function* actionSearchSaga({ payload: { params } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/subjects',
        params,
    });
    yield put({
        type: HANDLE_DATA,
        payload: result,
    });
}

const initialState = {
    gridData: defaultGridData,
};

const module = handleActions(
    {
        [ACTION_INIT]: (state) => initialState,
        [HANDLE_DATA]: (state, { payload }) => ({ ...state, gridData: payload }),
    },
    initialState,
);

export default module;
